import Radio from 'backbone.radio';
    var globalCh = Radio.channel('global');

    export default function() {
        var app_features = globalCh.request('app_options', 'features');
        /*
        // Possible Values to send for Analytics
        // eventCategory   text    yes Typically the object that was interacted with (e.g. 'Video')
        // eventAction     text    yes The type of interaction (e.g. 'play')
        // eventLabel      text    no  Useful for categorizing events (e.g. 'Fall Campaign')
        // eventValue      integer no  A numeric value associated with the event (e.g. 42)
        */

        globalCh.reply('GA_Event', function(eventCategory, eventAction, eventLabel) {
            if (app_features && app_features.ga_account) {
                window.ga('send', 'event', eventCategory, eventAction, eventLabel);
            }
        });

    }

